// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v3/deactivation_request_requirements.proto

/* oxlint-disable */

/** Defines an empty deactivation request requirements message, returned upon deactivation request creation. */
export interface ApiEmptyDeactivationRequestRequirements {
}

/** Defines the deactivation request requirements response message. */
export interface ApiDeactivationRequestRequirements {
  /** Organization has an authorized balance of zero. */
  readonly accountAuthorizedBalanceZero: boolean;
  /** Organization has a balance of zero. */
  readonly accountBalanceZero: boolean;
  /** Both authorized and settled balance are the same. */
  readonly balanceEqualToAuthorizedBalance: boolean;
  /** Organization has no active savings account. */
  readonly noActiveSavingsAccount: boolean;
  /** Organization has no pending checks. */
  readonly noPendingChecks: boolean;
}

export const ApiEmptyDeactivationRequestRequirements: MessageFns<ApiEmptyDeactivationRequestRequirements> = {
  fromJSON(_: any): ApiEmptyDeactivationRequestRequirements {
    return {};
  },

  toJSON(_: ApiEmptyDeactivationRequestRequirements): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiDeactivationRequestRequirements: MessageFns<ApiDeactivationRequestRequirements> = {
  fromJSON(object: any): ApiDeactivationRequestRequirements {
    return {
      accountAuthorizedBalanceZero: isSet(object.account_authorized_balance_zero)
        ? globalThis.Boolean(object.account_authorized_balance_zero)
        : false,
      accountBalanceZero: isSet(object.account_balance_zero) ? globalThis.Boolean(object.account_balance_zero) : false,
      balanceEqualToAuthorizedBalance: isSet(object.balance_equal_to_authorized_balance)
        ? globalThis.Boolean(object.balance_equal_to_authorized_balance)
        : false,
      noActiveSavingsAccount: isSet(object.no_active_savings_account)
        ? globalThis.Boolean(object.no_active_savings_account)
        : false,
      noPendingChecks: isSet(object.no_pending_checks) ? globalThis.Boolean(object.no_pending_checks) : false,
    };
  },

  toJSON(message: ApiDeactivationRequestRequirements): unknown {
    const obj: any = {};
    if (message.accountAuthorizedBalanceZero !== undefined && message.accountAuthorizedBalanceZero !== null) {
      obj.account_authorized_balance_zero = message.accountAuthorizedBalanceZero;
    }
    if (message.accountBalanceZero !== undefined && message.accountBalanceZero !== null) {
      obj.account_balance_zero = message.accountBalanceZero;
    }
    if (message.balanceEqualToAuthorizedBalance !== undefined && message.balanceEqualToAuthorizedBalance !== null) {
      obj.balance_equal_to_authorized_balance = message.balanceEqualToAuthorizedBalance;
    }
    if (message.noActiveSavingsAccount !== undefined && message.noActiveSavingsAccount !== null) {
      obj.no_active_savings_account = message.noActiveSavingsAccount;
    }
    if (message.noPendingChecks !== undefined && message.noPendingChecks !== null) {
      obj.no_pending_checks = message.noPendingChecks;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
